import { FetchWithAuth } from "digimaker-ui/util";
import { useEffect } from "react";
import { useHistory } from "react-router";
import * as React from "react";

export const Logout = () => {
  const history = useHistory();
  useEffect(() => {
    FetchWithAuth("user/logout").then((data) => {
      if (data.error === false) {
        history.push("/login");
      }
    });
  }, []);

  return <div></div>;
};
